
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_221_6600)","fill":"#525252"}},[_c('path',{attrs:{"d":"M8 16.5c-4.413 0-8-3.587-8-8s3.587-8 8-8 8 3.587 8 8-3.587 8-8 8zM8 1.833c-3.673 0-6.667 2.994-6.667 6.667 0 3.673 2.994 6.667 6.667 6.667 3.673 0 6.667-2.994 6.667-6.667 0-3.673-2.994-6.667-6.667-6.667z"}}),_c('path',{attrs:{"d":"M8.966 12.427A3.93 3.93 0 015.039 8.5a3.93 3.93 0 013.927-3.927c.366 0 .666.3.666.667 0 .367-.3.667-.666.667A2.596 2.596 0 006.372 8.5a2.592 2.592 0 002.594 2.593c.366 0 .666.3.666.667 0 .367-.3.667-.666.667z"}}),_c('path',{attrs:{"d":"M8.693 9.167H4.667A.669.669 0 014 8.5c0-.367.3-.667.667-.667h4.026c.367 0 .667.3.667.667 0 .367-.3.667-.667.667z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_221_6600"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    